<template>
<div class="selected-box-item">
  <div class="selected-box-item__text box-content">
    <slot></slot>
  </div>
  <div class="selected-box-item__remove box-content">
    <mds-button
      type="button"
      class="selected-box-item__remove-button"
      variation="icon-only"
      icon="remove"
      size="small"
      :text="`Remove Fund #${element.id}`"
      @click="handleRemoveClick"
    ></mds-button>
  </div>
</div>
</template>

<script>
import { get } from 'lodash';
import { MdsButton } from '@mds/button';

export default {
  name: 'selected-box-item',
  components: {
    MdsButton,
  },
  props: {
    element: {
      type: Object,
      required: true,
      validator: (value) => {
        return get(value, 'id');
      },
    },
  },
  methods: {
    handleRemoveClick() {
      this.$emit('item-removed', this.element);
      return true;
    },
  },
};
</script>

<style lang="scss">
.selected-box-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: $mds-color-white;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.21);
  margin-bottom: $mds-space-1-x;
}

.selected-box-item__text {
  flex: 1;
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $mds-color-neutral-20
}

.box-content {
  padding: $mds-space-1-x;

  &.selected-box-item__remove {
    padding-top: calc(#{$mds-space-1-x} - 2px);
  }
}
</style>

<style lang="scss" module>
// It overrides the style of mds-button--icon-only to match the required color of the icon in the box when it's hovered
:global(.selected-box-item) {
  .mds-button--icon-only  {
    &:hover,
    &:active,
    &:focus {
        .mds-icon {
            @include mds-icon-color($mds-color-blue-36);
        }
    }
  }
}
</style>
